import Cookies from 'js-cookie';
import { isBrowser } from '../../util/ssr';

export const isNewVisitor = () => {
  if (!isBrowser()) return true;
  return Cookies.get('optimizelyNewCustomerOfferEmailCaptureSuccess') ||
    Cookies.get('BOM-CAT')
    ? false
    : window.optimizely?.get?.('visitor')?.first_session;
};

export default {};
